/* IMPORTS */
import React from "react";
import gettext from "../../../shared/utils/gettext";
import {
  CorDetailsItemTypes,
  CorDetailsTypes,
  MatrixHeaderTypes,
  MatrixRowTypes,
  MatrixTypes,
} from "./ObjectInterfaces";

/* Assigning the prop types */
interface ViewMatrixProps {
  getDisplayName: any;
  matrixData: MatrixTypes;
  measurementDetails: CorDetailsTypes;
  visualizeCorrelation: any;
}

/* ViewMatrix Component */
export const ViewMatrix = ({
  getDisplayName,
  matrixData,
  measurementDetails,
  visualizeCorrelation,
}: ViewMatrixProps) => {
  /* Function collection the details and visualizing the correlation within a cell */
  const visualizeCell = (i: number, j: number) => {
    const var1Details: CorDetailsItemTypes = measurementDetails[matrixData.headers[i].key];
    const var2Details: CorDetailsItemTypes = measurementDetails[matrixData.headers[j].key];
    visualizeCorrelation(var1Details, var2Details);
  };

  /* JSX */
  return (
    <table className="table">
      <thead>
        <tr>
          <th className="cor">{gettext("Best Measurements")}</th>
          {matrixData.headers.map((header: MatrixHeaderTypes, i: number) => (
            <th className="cor" key={i}>
              {getDisplayName(header.code, header.name)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {matrixData.rows.map((row: MatrixRowTypes, i: number) => (
          <tr key={`${i + "tr"}`}>
            <th className="cor" key={i}>
              {getDisplayName(row.code, row.name)}
            </th>
            {row.values.map((val: number, j: number) => (
              <td
                className={val > 0.6 || val < -0.6 ? "bg-success cor" : "cor"}
                key={j}
                onClick={() => visualizeCell(i, j)}
              >
                {val?.toFixed(2)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
